import { Toaster } from 'components/notification/Toaster';
import usePromiseInstance_authorization from 'dataflow/distributorPortal/actions/config';
import { func_serviceHandling, func_validation, getTotalCountFromHeader } from 'functions';
import { useState } from 'react';

export function useTableData(currentTabId) {
    const [data, setData] = useState();
	const [isDataLoading, setIsDataLoading] = useState();
	const [totalRecords, setTotalRecords] = useState();
    const request = usePromiseInstance_authorization();

    function getData(pageNo, pageSize, sort, filterOptions = {}) {
        let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let paramObj = {
			offset: offset,
			limit: pageSize,
			...filterOptions
		}

		let apiPath = (currentTabId === "comList")? "/ComInfo/GetComId": "/ComInfo/GetRequest";
		let url = func_serviceHandling.createUrlWithParams(apiPath, paramObj)

		setIsDataLoading(true);

        request(null, (axios) => {
			axios.get(url)
				.then(function (response) {
					// handle success
					setTotalRecords(getTotalCountFromHeader(response?.headers))
					let data = response?.data;
					if (data) setData(data);
				})
				.catch(function (response) {
					// handle error
					if (response?.data?.exceptionMessage) {
						Toaster({
							type: "error",
							msg: response?.data?.exceptionMessage
						})
					}
				})
				.finally(function () {
					// always executed
					setIsDataLoading(false);
				});
		})
    }

    return {
        getData,
        data, totalRecords,
		isDataLoading
    }
}